var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8284 0.171628C19.6759 0.0192058 19.4521 -0.0372005 19.2457 0.0247136L1.32062 5.40226C0.530703 5.63921 0 6.35249 0 7.17745C0 7.99097 0.546289 8.71523 1.32855 8.93874L8.89843 11.1016L11.0612 18.6714C11.2848 19.4537 12.009 20 12.8228 20C13.6475 20 14.3608 19.4693 14.5978 18.6794L19.9753 0.754284C20.0372 0.547839 19.9808 0.32405 19.8284 0.171628ZM1.17187 7.17718C1.17187 6.87401 1.36695 6.61183 1.65734 6.52472L17.3564 1.81499L9.20187 9.96952L1.65047 7.81198C1.36871 7.73144 1.17187 7.47054 1.17187 7.17718ZM13.4753 18.3427C13.3882 18.633 13.126 18.8281 12.8225 18.8281C12.5294 18.8281 12.2685 18.6313 12.188 18.3495L10.0305 10.7981L18.185 2.64358L13.4753 18.3427Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.36ec9d75d8ffdaa4c6ddbd4999d4cfce.svg";
export { ForwardRef as ReactComponent };